import React from "react";
import { Navigate, Routes } from "react-router-dom";

import { Route } from "src/shared/components";
import {
  VolunteerRoute,
  Route as RouteConstants,
  BaseRoute,
} from "src/shared/constants/route";
import { Permission } from "src/shared/contexts";
import NotFound from "src/views/404";

import BufferInformationPage from "./buffer-information";
import CheckInPage from "./check-in";
import ContactPage from "./contact";
import { EventRedemption } from "./event-redemption";
import VolunteerHome from "./home";
import { Profile } from "./profile";
// The unchanged pre-2026 flow remains in "./registration" for a one-line rollback.
import { Registration } from "./registration/badge-registration";
import { AddShiftContextProvider } from "./shared/contexts/AddShiftContext";
import { EditShiftContextProvider } from "./shared/contexts/EditShiftContext";
import ShiftSchedulePage from "./shift-schedule";
import ShiftsPage from "./shifts";
import AddVolunteerShiftPage from "./shifts/add";
import EditVolunteerShiftPage from "./shifts/edit";
import UploadSpreadsheet from "./shifts/uploadSpreadsheet";
import VolunteersPage from "./volunteers";

export const VolunteerRoutes = () => {
  return (
    <AddShiftContextProvider>
      <EditShiftContextProvider>
        <Routes>
          <Route
            path={VolunteerRoute.HOME}
            element={<VolunteerHome />}
            requirePermissions={[Permission.VOLUNTEER_EVENT_ACCESS]}
            permissionDeniedTitle="Complete your RSVP"
            permissionDeniedMessage="Finish your volunteer RSVP before accessing the volunteer tool."
            permissionDeniedActionLabel="Go to RSVP"
            permissionDeniedRedirectTo={RouteConstants.HACKER_RSVP}
            permissionDeniedFor={Permission.VOLUNTEER_EVENT_ACCESS}
          />
          <Route
            path={VolunteerRoute.SHIFT_SCHEDULE}
            element={<ShiftSchedulePage />}
            requirePermissions={[Permission.VOLUNTEER_EVENT_ACCESS]}
            permissionDeniedTitle="Complete your RSVP"
            permissionDeniedMessage="Finish your volunteer RSVP before accessing the volunteer tool."
            permissionDeniedActionLabel="Go to RSVP"
            permissionDeniedRedirectTo={RouteConstants.HACKER_RSVP}
            permissionDeniedFor={Permission.VOLUNTEER_EVENT_ACCESS}
          />
          <Route
            path={VolunteerRoute.BUFFER_INFORMATION}
            element={<BufferInformationPage />}
            requirePermissions={[Permission.VOLUNTEER_EVENT_ACCESS]}
            permissionDeniedTitle="Complete your RSVP"
            permissionDeniedMessage="Finish your volunteer RSVP before accessing the volunteer tool."
            permissionDeniedActionLabel="Go to RSVP"
            permissionDeniedRedirectTo={RouteConstants.HACKER_RSVP}
            permissionDeniedFor={Permission.VOLUNTEER_EVENT_ACCESS}
          />
          <Route
            path={VolunteerRoute.SHIFTS}
            element={<ShiftsPage />}
            requirePermissions={[Permission.ORGANIZER]}
          />
          <Route
            path={VolunteerRoute.ADD_SHIFT}
            element={<AddVolunteerShiftPage />}
            requirePermissions={[Permission.ORGANIZER]}
          />
          <Route
            path={VolunteerRoute.EDIT_SHIFT}
            element={<EditVolunteerShiftPage />}
            requirePermissions={[Permission.ORGANIZER]}
          />
          <Route
            path={VolunteerRoute.UPLOAD_SHEET}
            element={<UploadSpreadsheet />}
            requirePermissions={[Permission.ORGANIZER]}
          />
          <Route
            path={VolunteerRoute.CHECK_IN}
            element={<CheckInPage />}
            requirePermissions={[Permission.ORGANIZER]}
          />
          <Route
            path={VolunteerRoute.VOLUNTEERS}
            element={<VolunteersPage />}
            requirePermissions={[Permission.ORGANIZER]}
          />
          <Route
            path={VolunteerRoute.CONTACT}
            element={<ContactPage />}
            requirePermissions={[Permission.VOLUNTEER_EVENT_ACCESS]}
            permissionDeniedTitle="Complete your RSVP"
            permissionDeniedMessage="Finish your volunteer RSVP before accessing the volunteer tool."
            permissionDeniedActionLabel="Go to RSVP"
            permissionDeniedRedirectTo={RouteConstants.HACKER_RSVP}
            permissionDeniedFor={Permission.VOLUNTEER_EVENT_ACCESS}
          />
          <Route
            path={VolunteerRoute.REGISTRATION}
            element={<Registration />}
            requirePermissions={[Permission.VOLUNTEER_EVENT_ACCESS]}
            permissionDeniedTitle="Complete your RSVP"
            permissionDeniedMessage="Finish your volunteer RSVP before accessing the volunteer tool."
            permissionDeniedActionLabel="Go to RSVP"
            permissionDeniedRedirectTo={RouteConstants.HACKER_RSVP}
            permissionDeniedFor={Permission.VOLUNTEER_EVENT_ACCESS}
          />
          <Route
            path={VolunteerRoute.EVENT_REDEMPTION}
            element={<EventRedemption />}
            requirePermissions={[Permission.VOLUNTEER_EVENT_ACCESS]}
            permissionDeniedTitle="Complete your RSVP"
            permissionDeniedMessage="Finish your volunteer RSVP before accessing the volunteer tool."
            permissionDeniedActionLabel="Go to RSVP"
            permissionDeniedRedirectTo={RouteConstants.HACKER_RSVP}
            permissionDeniedFor={Permission.VOLUNTEER_EVENT_ACCESS}
          />
          <Route
            path={VolunteerRoute.PROFILE}
            element={<Profile />}
            requirePermissions={[Permission.VOLUNTEER_EVENT_ACCESS]}
            permissionDeniedTitle="Complete your RSVP"
            permissionDeniedMessage="Finish your volunteer RSVP before accessing the volunteer tool."
            permissionDeniedActionLabel="Go to RSVP"
            permissionDeniedRedirectTo={RouteConstants.HACKER_RSVP}
            permissionDeniedFor={Permission.VOLUNTEER_EVENT_ACCESS}
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </EditShiftContextProvider>
    </AddShiftContextProvider>
  );
};

export const VolunteerHomeRoute = () => (
  <Route
    path={BaseRoute.HOME}
    element={<Navigate to={RouteConstants.VOLUNTEER_HOME} />}
  />
);
